type Route = {
  path: string;
  isInternal?: boolean;
};

// Helper function to properly type Routes list with keys and Route type values
// See: https://stackoverflow.com/a/54598743/3600105
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const createRoutesList = <T>(routes: { [K in keyof T]: Route }) => routes;

export const Routes = createRoutesList({
  HOME: {
    path: '/',
    isInternal: false,
  },
  PHONICS_MANAGE: {
    path: '/manage',
    isInternal: true,
  },
  PHONICS_MANAGE_LESSONS: {
    path: '/manage/lessons',
    isInternal: true,
  },
  PHONICS_MANAGE_LESSON: {
    path: '/manage/lessons/[lessonId]',
    isInternal: true,
  },
  PHONICS_MANAGE_STUDENTS: {
    path: '/manage/students',
    isInternal: true,
  },
  PHONICS_MANAGE_DECODABLE_BOOKS: {
    path: '/manage/decodable-books',
    isInternal: true,
  },
  PHONICS_MANAGE_ASSESSMENT: {
    path: '/manage/assessment',
    isInternal: true,
  },
  PHONICS_MANAGE_TRAINING: {
    path: '/manage/training',
    isInternal: true,
  },
  PHONICS_MANAGE_ADMIN_LESSONS: {
    path: '/manage/admin/lessons',
    isInternal: true,
  },
  PHONICS_MANAGE_ADMIN_SYMBOLS: {
    path: '/manage/admin/symbols',
    isInternal: true,
  },
  PHONICS_MANAGE_ADMIN_METRICS: {
    path: '/manage/admin/metrics',
    isInternal: true,
  },
  PHONICS_MANAGE_ADMIN_SCORING: {
    path: '/manage/admin/scoring',
    isInternal: true,
  },
});

export default Routes;
